<template>
  <DropDownInput
    :label="$t('calculator.profit-trend-form.select-year')"
    :dropdownTitle="$t('calculator.profit-trend-form.select-year.title')"
  >
    <template #value>
      {{ props.value}}
    </template>
    <template #default="{hide}">
      <SimpleListItem
        v-for="index in listLength"
        :key="index"
        :isSelected="getYear(index) === props.value"
        @click.native="selectYear(index, hide)"
      >
        {{ getYear(index) }}
      </SimpleListItem>
    </template>
  </DropDownInput>
</template>

<script setup lang="ts">
import DropDownInput from "@kano/components/ProfitCalculator/Form/DropDownInput.vue";
import SimpleListItem from "@kano/components/ProfitCalculator/Form/SimpleListItem.vue";
import { ref } from "vue";

const props = defineProps<{
  value: number,
  endYear: number,
  startYear: number,
}>();

const emit = defineEmits<{
  (event: 'input', value: number): void,
}>();

const listLength = ref<number>(props.endYear - props.startYear);
const getYear = (index: number) => {
  return props.startYear + (index - 1);
};
const selectYear = (index: number, callback) => {
  emit('input', getYear(index));
  callback();
};
</script>